import {useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import '../styles/thankYou.css';

const ThankYou = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { orderDetails, orderNumber, amountPaid, oldPoints, pointsEarned, purchaseId, shippingURL } = state || {};

    useEffect(() => {
        if (!purchaseId) {
            navigate("/", { replace: true });
        }
    }, [purchaseId, navigate]);

    if (!purchaseId) return null;

    return (
        <div className='container'>
            <Row>
                <Col className='mt-3 order_summary' lg={7} md={6} sm={12}>
                    <h2><strong>THANK YOU</strong></h2>
                    <p>Order ID: {purchaseId}</p>
                    <span>Your order has been confirmed and you will receive an order confirmation email shortly.</span>
                    <span>Click {""}
                        <a 
                            href={shippingURL} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ color: "blue", textDecoration: "underline" }} 
                        >
                            here
                        </a>
                            {" "} to track order shipment
                    </span>
                    {/* <button>PRINT RECEIPT</button> */}
                </Col>

                <Col className='' lg={5} md={6} sm={12}>
                    <div>
                        <img src='' />
                        <div className='reward_col'>
                            <h3><strong>MY POINTS BANK</strong></h3>
                            <div>
                                <p>PREVIOUS TOTAL</p>
                                <p>{oldPoints}</p>
                            </div>

                            <div>
                                <p>EARNED TODAY</p>
                                <p>{pointsEarned}</p>
                            </div>

                            <div>
                                <p><strong>NEW BALANCE</strong></p>
                                <p>{oldPoints + pointsEarned}</p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                <div className='table'>
                    <table>
                        <thead>
                            <tr>
                                <th>ITEM</th>
                                <th>PRICE</th>
                                <th>QTY</th>
                                <th>AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetails.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.productName}</td>
                                    <td>${item.price}</td>
                                    <td>{item.quantity}</td>
                                    <td>${(item.price * item.quantity).toFixed(2)}</td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="3"><strong>Total Paid(+Shipping fee)</strong></td>
                                <td><strong>${amountPaid}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Row>
        </div>
    )
}

export default ThankYou